import { render } from "./DashboardTabs.component.vue?vue&type=template&id=248e0b5c"
import script from "./DashboardTabs.component.vue?vue&type=script&lang=js"
export * from "./DashboardTabs.component.vue?vue&type=script&lang=js"

import "./DashboardTabs.component.vue?vue&type=style&index=0&id=248e0b5c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QTabs,QRouteTab});
